const incidentsReducer = (state = {}, action) => {
    switch (action.type) {
        default:
            return state
    }
};

export default incidentsReducer;